<mat-toolbar color="primary">

    <span class="application-name">{{applicationName}}</span>

    <span class="fill-remaining-space text-center">
        <span *ngIf="sessionService.supportSessionExpiration"
              class=""
              style="font-size: 16px;">
            {{ 'toolbar.message.support_session_active' | translate }}&nbsp;
            {{ sessionService.supportSessionExpiration | drDateTime }}
        </span >
         <a *ngIf="sessionService.supportSessionExpiration"
            mat-flat-button
            color="accent"
            class="iq-color-2"
            (click)="cancelSupportAccess()">
             {{ 'toolbar.btn.cancel_access' | translate | uppercase }}
         </a>
    </span>
  
    <span class="" [ngStyle]="{'margin-bottom': (sessionService.isSupportSessionActive ? '-30px' : '') }">

        <span class="greeting">{{ 'toolbar.greeting' | translate }} {{ currentUser?.user.actionListDisplayName }}</span>&nbsp;&nbsp;

        <button mat-icon-button [matMenuTriggerFor]="appMenu"
            id="{{idPrefix}}btn.open-menu"
            class="float-right">
            <mat-icon>menu</mat-icon>
        </button>

        <button mat-icon-button [matMenuTriggerFor]="languageMenu" 
            id="{{ idPrefix }}language.btn.open-menu"
            class="float-right">
            <mat-icon fontSet="fa" fontIcon="fa-globe-americas"></mat-icon>
        </button>

        <message-service 
            id="{{ idPrefix }}message-service.btn" 
            class="float-right">
        </message-service>

        <mat-menu #appMenu="matMenu">
            <ng-container *ngFor="let btn of menuButtons">
                <button mat-menu-item
                        id="{{idPrefix}}{{btn.id}}"
                        *ngIf="!btn.hide || !btn.hide()"
                        (click)="btn.action()">
                    <mat-icon>{{ btn.icon }}</mat-icon>
                    <span>{{ btn.text | translate }}</span>
                </button>
            </ng-container>
        </mat-menu>

        <mat-menu #languageMenu="matMenu"
                  class="background-iq-color-1-lightest">
            <ng-container *ngFor="let btn of languageButtons">
                <button mat-menu-item
                        id="{{ idPrefix }}{{ 'language.btn.' }}{{ btn.id }}"
                        (click)="btn.action()"
                        class="mat-option"
                        [ngClass]="{'mat-active': activeLocale.shortName == btn.id}">
                    <span>{{ btn.text | translate }}</span>
                </button>
            </ng-container>
        </mat-menu>
        
    </span>

    <span class="support-warning" *ngIf="sessionService.isSupportSessionActive">
        <i class="fas fa-info-circle"></i>&nbsp;
        <strong>{{ 'toolbar.message.support_session_active_warning' | translate }}</strong>
    </span>
</mat-toolbar>
